import {Component, Module} from 'app/decorators';
import SalesPersonStore from 'app/stores/sales_person';

import BasePicker from './base.picker';
import tpl from './sales_person.picker.html';


@Module({
    name: "app.directives.salesPerson",
    modules: [SalesPersonStore],

})
@Component({
    selector: 'blnd-salesperson-picker',
    bindings: {
        ngModel: '=',
        ngChange: '&',
        mode: '@?',
        placeholder: '@?',
    },
    template: tpl,
})
export default class C extends BasePicker {
    constructor ($scope, $element, SalesPersonStore) {
        "ngInject";
        super($element);
        this.scope = $scope;
        this.store = SalesPersonStore;
        this.store.init();

        if (this.mode === 'search') {
            this.store.refresh();
        }
    }

    $onInit () {
        let self = this;
        this.scope.$watch(() => this.ngModel, function () {
            self.onChange();
        });
    }

    onChange () {
        if (this.ngChange) {
            this.ngChange();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/sales_person.picker.js